import { render } from "./Textarea.vue?vue&type=template&id=0b8f6734"
import script from "./Textarea.vue?vue&type=script&lang=ts"
export * from "./Textarea.vue?vue&type=script&lang=ts"
script.render = render

export default script